export default "__VITE_ASSET__5608d40c__"